import LandingPage from './LandingPage.container';

export type { LandingPageProps } from './LandingPage';
export default LandingPage;
